module.exports = __webpack_public_path__ + "static/img/btn1.8e12ad1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/btn1.png
// module id = xgPv
// module chunks = 1